import { createUseCertificateData } from '@akyga/shared-ui/useCertificateData';
import httpClient from 'API/httpClient';

export default createUseCertificateData(httpClient);
